import api from '@/api'

const state = {

}

const actions = {
  async checkUserName ({state}, payload) {
    const result = await api.userApi.validateUserName(payload)
    return result
  },
  async checkPhone ({state}, payload) {
    const result = await api.userApi.validatePhone(payload)
    return result
  },
  async checkEmail ({state}, payload) {
    const result = await api.userApi.validateEmail(payload)
    return result
  },
  async registerUserByAdmin ({state}, payload) {
    const result = await api.userApi.registerUserByAdmin(payload)
    return result
  },
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
